import BillingBreakdown from "../../models/BillingBreakdown";
import { TripSearchFsmContext } from "../trip-search/TripSearchFsmContext";
import { ArticleDTO, PromoCodeVerifiedResponseDTO, TentativeBookingDTO } from "../../apiclient/ApiDtos";

export class PaymentAttemptFsmContext {
    constructor(
        public readonly tripSearchContext: TripSearchFsmContext,
        public readonly tenativeBooking : TentativeBookingDTO,  
        public readonly billingBreakdown: BillingBreakdown,
        public readonly appliedPromoResult: PromoCodeVerifiedResponseDTO | null = null,
        public readonly applyingPromoCode: string | null = null,
        public readonly promoCodeApplyError: boolean,
        public readonly paymentTerms: ArticleDTO | null = null,  
        public readonly paymentErrorMessage?: string | null
    ) {}     
    
    withEnteredPromoCode(promo: string){
        return new PaymentAttemptFsmContext(
            this.tripSearchContext,
            this.tenativeBooking,
            this.billingBreakdown,
            null,
            promo,
            false,
            this.paymentTerms,
            this.paymentErrorMessage            
        )
    }

    withVerifiedPromoSuccessResult(result: PromoCodeVerifiedResponseDTO){
        return new PaymentAttemptFsmContext(
            this.tripSearchContext,
            this.tenativeBooking,
            this.billingBreakdown,
            result,
            this.applyingPromoCode,
            false,
            this.paymentTerms,
            this.paymentErrorMessage       
        )
    }
    
    withPromoVerificationError(){
        return new PaymentAttemptFsmContext(
            this.tripSearchContext,
            this.tenativeBooking,
            this.billingBreakdown,
            null,
            this.applyingPromoCode,
            true,
            this.paymentTerms,
            this.paymentErrorMessage       
        )
    }


    withoutPromo(){
        return new PaymentAttemptFsmContext(
            this.tripSearchContext,
            this.tenativeBooking,
            this.billingBreakdown,
            null,
            null,
            false,
            this.paymentTerms,
            this.paymentErrorMessage
        )
    }
}
